import { styled } from '@mui/material/styles';
import { Card as MuiCard } from '@mui/material';

export const StyledCard = styled(MuiCard)(({ theme }) => ({
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: theme.palette.outline,
}));
